import CCTerminal from 'app/src/data/models/CCTerminal';
import Terminal from 'app/src/payments/terminals/Terminal';

export default class BluetoothTerminal extends Terminal {
  constructor(model: CCTerminal) {
    super(model);
  }
}
